import React, { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MaterialTable from 'material-table';
import AuthUser from '../../../../Components/AuthUser';
import ReactDatePicker from 'react-datepicker';
import { purchaseInLang } from '../../../../Components/language/pages/purchaseInLang';
import useLanguage from '../../../../Components/language/useLanguage';
function VieMaterialReceiving() {
  const { id } = useParams();

  const lan = useLanguage(purchaseInLang);
  const navigate = useNavigate();
  const { http, user } = AuthUser();

  const [mrrDetails, setMrrDetails] = useState({
    purchase_order_no_id: '',
    manufacturer_id: '',
    supplier_id: '',
    // expiry_date: "",
    mrr_no: '',
    carrier_id: '',
    delivery_date: '',
    carried_by: '',
    contact_no: '',
    vehicle_no: '',
    remarks: '',
    total_bill_amount: '',
    paid_amount: '',
    due_amount: '',
    delivery_no_docs: '',
    payment_type: '',
    mrr_expiry_date: '',
    vat: 0
  });
  const [cart, setCart] = useState([]);
  useEffect(() => {
    http.get(`mrr-details/${id}`).then((res) => {
      console.log(res, 'mrr_res');
      setMrrDetails(res.data.mrr);
      setCart(res.data.mrr.mrr_details);
    });
  }, []);

  // product requisition

  const columnsData = [
    {
      title: lan?.name,
      render: (row) => (
        <div className='text-capitalize text-center'>
          {row?.drug?.macrohealth_sg}
        </div>
      ),
      width: '100 !important',
    },
    {
      title: lan?.bonusQty,
      render: (row) => (
        <div className='text-capitalize text-center'>
          {(parseFloat(row?.bonus_qty)).toFixed(2)}
        </div>
      ),
    },
    {
      title: lan?.unit,
      field: 'unit',
      render: (row) => (
        <div className='text-capitalize text-center'>{row.unit}</div>
      ),
    },
    {
      title: lan?.quantity,
      field: 'req_unit',
      render: (row) => (
        <div className='w-[100%]'>
          <input
            className='form-control form-control-sm'
            value={row.req_unit}
            style={{ width: '80px', margin: 'auto' }}
            readOnly
            type='number'
          />
        </div>
      ),
    },
    {
      title: lan?.pp,
      render: (row) => (
        <div className='text-capitalize text-center'>
          {parseFloat(row?.price).toFixed(2)}
        </div>
      ),
    },
    {
      title: lan?.vat,
      render: (row) => (
        <div className='text-capitalize text-center'>
          {parseFloat(row?.vat).toFixed(2)}
        </div>
      ),
    },
    {
      title: lan?.discount,
      render: (row) => (
        <div className='text-capitalize text-center'>
          {parseFloat(row?.disc).toFixed(2)}
        </div>
      ),
    },

    { title: lan?.totalPrice, render: (row) => <div className='text-capitalize text-center'>{(parseFloat(row?.totalPrice)).toFixed(2)}</div> },
  ];
  
  return (
    <div className='page-content mrr-data'>
      <div className='custom-card patients-head '>
        <h5 className='fw-normal custom_py-3 px-2  text-start mb-2 card-title'>
          {lan?.pageTitle}
          <button
            className='btn btn-sm btn-warning float-end'
            onClick={() => navigate(-1)}
          >
            <i class='fal fa-long-arrow-left'></i> {lan?.back}
          </button>
        </h5>
      </div>

      {/* <form  onSubmit={submitFormData}> */}

      <div className='row'>
        <div className='col-lg-8 col-md-8'>
          <div className='card'>
            <div className='card-body'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='row mb-2'>
                    <label
                      htmlFor='exampleInputUsername2'
                      className='col-sm-5'
                    >
                      {lan?.referenceInvoiceNo}

                    </label>
                    <div className='col-sm-7'>
                      <input type="text" readOnly value={mrrDetails.reference_invoice_no} className='form-control form-control-sm' />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='row '>
                    <label
                      htmlFor='exampleInputUsername2'
                      className='col-sm-5'
                    >
                      {lan?.referenceOrderNo}
                    </label>
                    <div className='col-sm-7'>
                      <input type="text" readOnly value={mrrDetails.reference_order_no} className='form-control form-control-sm' />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className='row mb-2'>
                    <label htmlFor='exampleInputUsername2' className='col-sm-5'>
                      {lan?.purchaseInNo} .
                    </label>
                    <div className='col-sm-7'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        id='exampleInputUsername2'
                        value={mrrDetails.mrr_no}
                        name='mrr_no'
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className='row mb-2'>
                    <label
                      htmlFor='exampleInputUsername2'
                      className='col-sm-5 col-form-label'
                    >
                      {lan?.orderBy}
                    </label>
                    <div className='col-sm-7'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        id='exampleInputUsername2'
                        value={user.name}
                        name='requisition_no'
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='row mb-2'>
                    <label htmlFor='exampleInputUsername2' className='col-sm-5'>
                      {lan?.deliveryDate}
                    </label>
                    <div className='col-sm-7'>
                      {/* {moment().format('DD-MM-YYYY')} */}
                      <ReactDatePicker
                        placeholderText='DD/MM/YYYY'
                        className='form-control form-control-sm custom-datepicker-input-width'
                        selected={
                          mrrDetails.delivery_date &&
                          new Date(mrrDetails.delivery_date)
                        }
                        disabled

                        dateFormat='dd/MM/yyyy'
                      />

                    </div>
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className='row mb-2'>
                    <label htmlFor='exampleInputUsername2' className='col-sm-5'>
                      {lan?.supplier}
                    </label>
                    <div className='col-sm-7'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        id='exampleInputUsername2'
                        value={mrrDetails?.supplier?.supplier_name}
                        name='requisition_no'
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='mt-1'>
                    <div className=''>
                      <textarea
                        name='remarks'
                        readOnly
                        value={mrrDetails.remarks}
                        className='form-control '
                        placeholder={`${lan?.remarks} ...`}
                        rows='2'
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className='col-lg-4 col-md-4 requisition_status_blog'>


          <div className='card payment_block'>
            <div className='card-body'>
              <div className='row'>
                <div className='col-md-12'>
                  <h6>{lan?.payment}</h6>
                  <hr className='mrr_heading' />
                  <div className='d-flex'>
                    <div className='form-check mb-2'>
                      <input
                        type='radio'
                        className='form-check-input mt-1'
                        value='cash'
                        name='payment_type'
                        id='cash_payment1'
                        checked={mrrDetails?.payment_type === 'cash'}
                        disabled
                      />
                      <label
                        className='form-check-label me-2'
                        htmlFor='cash_payment1'
                      >
                        {lan?.cash}
                      </label>
                    </div>
                    <div className='form-check mb-2'>
                      <input
                        type='radio'
                        className='form-check-input mt-1'
                        value='card'
                        name='payment_type'
                        id='card_payment1'
                        checked={mrrDetails?.payment_type === 'card'}
                        disabled
                      />
                      <label
                        className='form-check-label me-2'
                        htmlFor='card_payment1'
                      >
                        {lan?.creditDebitCard}
                      </label>
                    </div>
                    <div className='form-check mb-2'>
                      <input
                        type='radio'
                        className='form-check-input mt-1'
                        value='due'
                        name='payment_type'
                        id='due_payment1'
                        checked={mrrDetails?.payment_type === 'due' || (!mrrDetails?.payment_type && parseFloat(mrrDetails?.due_amount) > 0)}
                        disabled
                      />
                      <label
                        className='form-check-label me-2'
                        htmlFor='due_payment1'
                      >
                        {lan?.due}
                      </label>
                    </div>
                  </div>
                  {/* Row 1: Sub Total | Vat */}
                  <div className='row mb-1'>
                    <div className='col-md-6'>
                      <div className='row mb-1'>
                        <label htmlFor='exampleInputUsername2' className='col-sm-4'>
                          {lan?.subTotal}
                        </label>
                        <div className='col-sm-8'>
                          <input
                            type='number'
                            className='form-control form-control-sm'
                            id='exampleInputUsername2'
                            value={(parseFloat(mrrDetails?.total_bill_amount ? mrrDetails?.total_bill_amount : 0) + parseFloat(mrrDetails?.special_discount ? mrrDetails?.special_discount : 0) - parseFloat(mrrDetails?.vat ? mrrDetails?.vat : 0)).toFixed(2)}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='row mb-1'>
                        <label htmlFor='exampleInputUsername2' className='col-sm-4'>
                          {lan?.vat}
                        </label>
                        <div className='col-sm-8'>
                          <input
                            type='number'
                            className='form-control form-control-sm'
                            id='exampleInputUsername2'
                            value={parseFloat(mrrDetails?.vat ? mrrDetails?.vat : 0).toFixed(2)}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row 2: Discount | Grand Total */}
                  <div className='row mb-1'>
                    <div className='col-md-6'>
                      <div className='row mb-1'>
                        <label htmlFor='exampleInputUsername2' className='col-sm-4'>
                          {lan?.discount}
                        </label>
                        <div className='col-sm-8'>
                          <input
                            type='number'
                            className='form-control form-control-sm'
                            id='exampleInputUsername2'
                            value={parseFloat(mrrDetails?.special_discount ? mrrDetails?.special_discount : 0).toFixed(2)}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='row mb-1'>
                        <label htmlFor='exampleInputUsername2' className='col-sm-4'>
                          {lan?.grandTotal}
                        </label>
                        <div className='col-sm-8'>
                          <input
                            type='number'
                            className='form-control form-control-sm'
                            id='exampleInputUsername2'
                            value={parseFloat(mrrDetails?.total_bill_amount ? mrrDetails?.total_bill_amount : 0).toFixed(2)}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Row 3: Paid | Due */}
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='row'>
                        <label
                          htmlFor='exampleInputUsername2'
                          className='col-sm-4 col-form-label'
                        >
                          {lan?.paid}
                          <span>*</span>
                        </label>
                        <div className='col-sm-8'>
                          <input
                            type='number'
                            className='form-control form-control-sm'
                            id='exampleInputUsername2'
                            name='paid_amount'
                            value={parseFloat(mrrDetails?.paid_amount ? mrrDetails?.paid_amount : 0).toFixed(2)}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='row'>
                        <label
                          htmlFor='exampleInputUsername2'
                          className='col-sm-4 col-form-label'
                        >
                          {lan?.due}
                        </label>
                        <div className='col-sm-8'>
                          <input
                            type='number'
                            className='form-control form-control-sm'
                            id='exampleInputUsername2'
                            readOnly
                            value={parseFloat(mrrDetails?.due_amount ? mrrDetails?.due_amount : 0).toFixed(2)}
                            name='due_amount'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*requisition list*/}

      <div className='row mt-2'>
        <div className='col-md-12 col-mg-12'>
          <MaterialTable
            title={<h6 style={{ fontWeight: '500' }}>Product Details</h6>}
            columns={columnsData}
            data={cart}
            options={{
              actionsColumnIndex: -1,
              selection: false,
              search: false,
              showTitle: true,
              pageSize: 5,
              pageSizeOptions: [5, 10, 20, 50, 100],
              emptyRowsWhenPaging: false,
              rowStyle: {
                fontSize: '.75rem',
                textAlign: 'center',
              },
              headerStyle: {
                fontSize: '.75rem',
                border: '1px solid #c9c9c9',
                textAlign: 'center',
                zIndex: '0',
                whiteSpace: 'nowrap',
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default VieMaterialReceiving;
